module.exports = __webpack_public_path__ + "img/V-L-2-unload-connect.dff177f8.png";